module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.contact.contact_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.contact.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.contact.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.contact.mail))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.contact.detail))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-527636ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contact/ListRow.vue
// module id = 455
// module chunks = 1